
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";

import { LANGUAGE_API_PATH, TAG_API_PATH } from "../../network/config/apiPaths";
import axios from "axios";
import { displayUrl, formUpdateData, updateFormInfo, updatePoadcastUrl } from "../../redux/slice/formUpdateSlice";
import { updateMessage } from "../../redux/slice/toastSlice";
import { changeStatus } from "../../redux/slice/loaderSlice";
import { poadcastCreateUpdateAction } from "../../network/store/action/CategoryResponseAction";
import Select from "react-select"
import FirebaseIntegration from "../dashboard/firbase-integration";
import { ProgressBar } from "react-bootstrap";
import {ref, uploadBytesResumable, getDownloadURL} from 'firebase/storage'
import { storage } from "../../firebase";

function AddPoadcast(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const formData = useSelector(formUpdateData);
    const itemInfo = formData.item;

    
    console.log("add poadcast", itemInfo!=null&&itemInfo.info)
    const [langList, setLangList] = useState([]);
    const [tagList, setTagList] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [inputFeilds, setInputFeilds] = useState({
        name: itemInfo != null ? itemInfo.info.name : "",
        language: itemInfo != null ? itemInfo.info.language_id : "",
        poadcastUrl: itemInfo != null ? itemInfo.info.poadcast_url : "",
        description: itemInfo != null ? itemInfo.info.description : "",
        uploadType: itemInfo != null ? 1 : null,
    })
    const [file, setFile] = useState(null);
    const [progress, setProgress] = useState(0);
    const [poadUrl, setUrl] = useState();

    const handleInputUpload = (e) => {
        let selectedFile = e.target.files[0]
        selectedFile && setFile(selectedFile)
    }
    // useEffect(() => {
    //     setInputFeilds(inputFeilds => ({ ...inputFeilds, poadcastUrl: poadUrl }))
    // }, [poadUrl])
    console.log("inputFeild", inputFeilds)
    const [selectedTags, setSelectedTags] = useState([])
    const [selectedTagIds, setSelectedTagIds] = useState([])

    // const[ defaultIds,setDefaultIds]=useState([])


    const callBack = (childData) => {
        setInputFeilds({ ...inputFeilds, poadcastUrl: childData })
    }
    var defaultIds = []
    const updateDefaultList = (options) => {
        var dOptions = [];
        var updatedDefaultIds = [];
        defaultIds.map((item, i) => {
            const defItem = options.find((element) => {
                return element.id === item;
            });

            if (defItem !== undefined) {
                console.log("defItem", defItem);
                dOptions.push(defItem);
            } else {
                updatedDefaultIds = defaultIds.filter(function (sitem) {
                    console.log("defItem", `${sitem} --- ${item}`);
                    return sitem !== item;
                });
            }
        });

        defaultIds = updatedDefaultIds.length > 0 ? updatedDefaultIds : defaultIds;
        setSelectedTags(dOptions);
        setSelectedTagIds(defaultIds);
    };

    const handleChange = (e) => {
        setInputFeilds({
            ...inputFeilds,
            [e.target.name]: e.target.value
        })
    }

    useEffect(() => {
        languageApi();
        if (itemInfo !== undefined)
            itemInfo.tags.map(item => defaultIds.push(item.id))

        tagsApi();

    }, []);

    const languageApi = async () => {
        let data = await axios.get(API_CONFIG.API_HOST + LANGUAGE_API_PATH.LANGUAGE_LIST, {
            headers: API_HEADERS
        })
        // consoleLog("language data",data.data.result);
        setLangList(data.data.result)
    };
    const tagsApi = async () => {
        let data = await axios.get(API_CONFIG.API_HOST + TAG_API_PATH.LIST_PATH, {
            headers: API_HEADERS
        })
        // consoleLog("language data",data.data.result);
        setTagList(data.data.result)
        updateDefaultList(data.data.result)
    };

    const onSubmtClick = async () => {
        if (inputFeilds.language == "" && inputFeilds.poadcastUrl == "" && inputFeilds.name == "" && selectedTagIds.length == 0 && selectedTags.length == 0) {
            dispatch(updateMessage({ display: true, message: "Enter all fields" }));
            return;
        }
        dispatch(changeStatus(true));
        let requestBody = {
            poadcastUrl: inputFeilds.poadcastUrl,
            languageId: inputFeilds.language,
            name: inputFeilds.name,
            tags: selectedTagIds.toString(),
            albumId: props.albumId,
            description: inputFeilds.description
        };

        if (itemInfo != undefined) {
            requestBody.id = itemInfo.info.id;
        }

        if (inputFeilds.language != "" && inputFeilds.poadcastUrl != "" && inputFeilds.name != "" && selectedTagIds.length != 0 && selectedTags.length != 0) {
            console.log("inside api")
            await dispatch(poadcastCreateUpdateAction(requestBody)).then((response) => {


                if (response.status == true) {
                    if (props.onSubmit) {
                        props.onSubmit();
                        dispatch(updatePoadcastUrl({ url: "" }))
                    };
                } else {
                    dispatch(
                        updateMessage({
                            display: true,
                            message: "Error While updating info",
                        })
                    );
                }
            });
        }
    };

    const uploadFile = () => {

        if (!file) {
            alert("First select the file")
            return;
        }
        const storageRef = ref(storage, `files/${file.name}`);

        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                let calculateProgess = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                setProgress(Math.round(calculateProgess))
            },
            (error) => {
                console.log("error occured while uploading", error)
            },
            () => {
                getDownloadURL(storageRef).then((downloadURL) => {
                    setUrl(downloadURL);
                    setInputFeilds(inputFeilds => ({ ...inputFeilds, poadcastUrl: downloadURL }))
                    console.log("url", downloadURL)
                }
                )
            }
        );
    }

    return (
        <>
            {/* {isLoading && <AppLodingBar />} */}
            <div
                style={{
                    position: "fixed",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    width: "100%",
                    height: "100%",
                    zIndex: "999",
                    overflow: "scroll",

                }}
            >
                <div className="d-flex align-item-center justify-content-center">
                    <div className="col-md-8">
                        <div className="container">
                            <div className="row mt-5">
                                <div className="col-md-5 card-1 p-5">

                                    <h4 className="text-center">{itemInfo != null ? "Update Poadcast" : "Add Poadcast"}</h4>


                                    <div className="col-md-12">
                                        <div className="form-group">

                                            <label className={isSubmit ? inputFeilds.name == "" ? "error-text" : "" : ""}>
                                                Name
                                            </label>
                                            <input type="text" className={`form-control ${isSubmit ? inputFeilds.name == "" ? "error-border" : "" : ""}`} onChange={handleChange} value={inputFeilds.name} name="name" />


                                            <label className={isSubmit ? inputFeilds.language == "" ? "error-text" : "" : ""}>
                                                Language
                                            </label>
                                            <select className={`form-control ${isSubmit ? inputFeilds.language == "" ? "error-border" : "" : ""}`} onChange={handleChange} value={inputFeilds.language} name="language">
                                                <option value={""}>{"--Select Language--"}</option>
                                                {
                                                    langList && langList.length > 0 ?

                                                        langList.map(item => {
                                                            return (
                                                                <option value={item.id}>{item.name}</option>
                                                            )
                                                        }) : <>No Data</>
                                                }
                                            </select>
                                            <label className={isSubmit ? inputFeilds.uploadType == null ? "error-text" : "" : ""}>Upload Type</label>
                                            <select className={`form-control ${isSubmit ? inputFeilds.uploadType == null ? "error-border" : "" : ""}`} onChange={handleChange} value={inputFeilds.uploadType} name="uploadType">
                                                <option value={""}>
                                                    {"--Select Upload type--"}
                                                </option>
                                                <option value={0}>Mp3/Mp4</option>
                                                <option value={1}>Links</option>
                                            </select>
                                            {
                                                inputFeilds.uploadType == 0 && <>
                                                    <label>
                                                        Poadcast File
                                                    </label>
                                                    <div className="d-flex flex-row">
                                                        <input type="file" accept="audio/mp3,video/mp4" onChange={handleInputUpload} className="form-control mr-1" placeholder="Upload file" />

                                                        <button className="btn btn-success" onClick={uploadFile}>Upload</button>
                                                    </div>
                                                    {progress>0?<ProgressBar now={progress} label={`${progress}%`} className="mt-3 w-100"/>:progress===100?()=>setProgress(0):""}

                                                    <label>
                                                        Poadcast Url
                                                    </label>
                                                    <input type="url" className="form-control" onChange={handleChange} value={inputFeilds.poadcastUrl} name="poadcastUrl" />

                                                </>

                                            }
                                            {
                                                inputFeilds.uploadType == 1 && <><label>
                                                    Poadcast Url
                                                </label>
                                                    <input type="url" className="form-control" onChange={handleChange} value={inputFeilds.poadcastUrl} name="poadcastUrl" />
                                                </>
                                            }

                                            <label className={isSubmit ? selectedTagIds.length == 0 ? "error-text" : "" : ""}>
                                                Tags
                                            </label>
                                            <Select
                                                value={selectedTags}
                                                name="selectedTags"
                                                className={isSubmit ? selectedTagIds.length == 0 ? "error-border-tag" : "" : ""}
                                                isMulti
                                                options={tagList}

                                                getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.id}`}
                                                onChange={(sOptions) => {
                                                    let tagsId = []

                                                    sOptions.map(item => tagsId.push(item.id))

                                                    setSelectedTags(sOptions);
                                                    setSelectedTagIds(tagsId)
                                                }}

                                            />
                                            <label>
                                                Description
                                            </label>
                                            <input type="text" className="form-control" onChange={handleChange} value={inputFeilds.description} name="description" />

                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">

                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginTop: 20,
                                                }}
                                            >
                                                <button
                                                    style={{ display: "flex", justifyContent: "center" }}
                                                    type="button"
                                                    className="btn btn-purple-bg"
                                                    onClick={() => { onSubmtClick(); setIsSubmit(true) }}

                                                >
                                                    Ok
                                                </button>
                                                <button
                                                    className="btn btn-white-bg"
                                                    onClick={() => {
                                                        dispatch(
                                                            updateFormInfo({
                                                                displayForm: false,
                                                                formData: {},
                                                            })
                                                        );
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default AddPoadcast